import React from "react";
import { useAppSelector } from "../../../store/index.ts";
import ShowContainer from "../ShowContainer.jsx";
import ChoseLang from "./ChoseLang.jsx";

export default function ChooseLangController() {
  const isTgBot = useAppSelector((state) => state.common.isTgBot);

  return (
    <ShowContainer condition={!isTgBot}>
      <ChoseLang />
    </ShowContainer>
  );
}
